import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Jaw } from '@libs/ui-lib';
import { PerioFormToothNavigatorButtonComponent } from '../perio-form-tooth-navigator-button/perio-form-tooth-navigator-button.component';

const OPPOSITE_TOOTH_SUM = 33;

@Component({
  selector: 'lib-perio-form-tooth-navigator',
  imports: [PerioFormToothNavigatorButtonComponent],
  templateUrl: './perio-form-tooth-navigator.component.html',
  styleUrl: './perio-form-tooth-navigator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PerioFormToothNavigatorComponent {
  public toothNumber = input.required<number>();
  public activeJaw = input.required<Jaw>();
  public isFirstTooth = input.required<boolean>();
  public isLastTooth = input.required<boolean>();
  public currentSide = input.required<'buccal' | 'lingual'>();
  public stepForward = output<void>();
  public stepBackward = output<void>();
  public switchToLingual = output<void>();
  public switchToFacial = output<void>();
  public switchToOppositeJawLingual = output<number>();

  protected onBackButtonClick(): void {
    if (this.currentSide() === 'lingual') {
      this.stepForward.emit();
    } else {
      this.stepBackward.emit();
    }
  }

  protected onNextButtonClick(): void {
    if (this.currentSide() === 'lingual') {
      this.stepBackward.emit();
    } else {
      this.stepForward.emit();
    }
  }

  protected onUpButtonClick(): void {
    if (this.currentSide() === 'lingual') {
      if (this.activeJaw() === 'upper') {
        // Upper jaw lingual + UP → switch to facial on same jaw
        this.switchToFacial.emit();
      } else {
        // Lower jaw lingual + UP → switch to upper jaw lingual
        const targetTooth = OPPOSITE_TOOTH_SUM - this.toothNumber();
        this.switchToOppositeJawLingual.emit(targetTooth);
      }
    } else {
      // When on buccal/facial, switch to lingual/facial on same jaw
      if (this.activeJaw() === 'upper') {
        this.switchToFacial.emit();
      } else {
        this.switchToLingual.emit();
      }
    }
  }

  protected onDownButtonClick(): void {
    if (this.currentSide() === 'lingual') {
      if (this.activeJaw() === 'lower') {
        // Lower jaw lingual + DOWN → switch to facial on same jaw
        this.switchToFacial.emit();
      } else {
        // Upper jaw lingual + DOWN → switch to lower jaw lingual
        const targetTooth = OPPOSITE_TOOTH_SUM - this.toothNumber();
        this.switchToOppositeJawLingual.emit(targetTooth);
      }
    } else {
      // When on buccal/facial, switch to lingual/facial on same jaw
      if (this.activeJaw() === 'upper') {
        this.switchToLingual.emit();
      } else {
        this.switchToFacial.emit();
      }
    }
  }
}
